import React from 'react'
import { translate } from 'react-translate'
import { DropdownButton, MenuItem } from 'react-bootstrap'

import './TranslationSwitch.scss'

const  TranslationSwitch = ({ available, onChange, currentLanguage }) => (
  <div>
    <DropdownButton
      id='dropdown-language'
      className='translation-selector'
      title={currentLanguage.split('-')[0].toUpperCase( )}
      onSelect={ (eventKey) => { onChange(eventKey) }}
    >
      {available.map((item, index) =>
        <MenuItem eventKey={item} key={index}>
          {item.split('-')[0].toUpperCase()}
        </MenuItem>
      )}
    </DropdownButton>
  </div>
)

export default translate('TranslationsSwitch')(TranslationSwitch)



// WEBPACK FOOTER //
// ./src/components/Translation/index.js